var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.64,
    height: 18.674,
    viewBox: "0 0 18.64 18.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone-call",
    "data-name": "Icon feather-phone-call",
    d: "M20.306,15.219V17.8a1.723,1.723,0,0,1-1.879,1.723,17.054,17.054,0,0,1-7.437-2.646,16.8,16.8,0,0,1-5.17-5.17A17.054,17.054,0,0,1,3.175,4.24,1.723,1.723,0,0,1,4.89,2.362H7.475A1.723,1.723,0,0,1,9.2,3.844a11.065,11.065,0,0,0,.6,2.421,1.723,1.723,0,0,1-.388,1.818L8.319,9.178a13.788,13.788,0,0,0,5.17,5.17l1.094-1.094a1.723,1.723,0,0,1,1.818-.388,11.065,11.065,0,0,0,2.421.6A1.723,1.723,0,0,1,20.306,15.219Z",
    transform: "translate(-2.417 -1.612)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6b9435f678f8bbdce2e3da36bab825a1.svg";
export { ForwardRef as ReactComponent };